export const RECORDING_STATE = Object.freeze({
  STARTED: 'started',
  STOPPED: 'stopped',
  UPLOADED: 'uploaded',
  FAILED: 'failed'
});
